// Others
import axiosClient from './axiosClient';
import { urlApiService } from '~/utils/constants/apis';
import { CONTENT_TYPE_FORM_DATA } from '~/utils/constants/common';
import { IBaseResponse, IListDataResponse } from '~/utils/interface/base';
import { IQueryParamService, IService, IServiceDetail, IQueryUpdateService } from '~/utils/interface/service';

const serviceApi = {
  getServiceList: (params: IQueryParamService) => {
    const url = urlApiService.getServiceList;
    return axiosClient.get<IBaseResponse<IListDataResponse<IService[]>>>(url, { params });
  },

  createService: (formData: FormData) => {
    const url = urlApiService.createService;
    return axiosClient.post<IBaseResponse>(url, formData, {
      headers: { 'Content-Type': CONTENT_TYPE_FORM_DATA },
    });
  },

  getServiceDetail: (serviceId: string) => {
    const url = urlApiService.getServiceDetail(serviceId);
    return axiosClient.get<IBaseResponse<IServiceDetail>>(url);
  },

  updateService: ({ serviceId, body }: IQueryUpdateService) => {
    const url = urlApiService.updateService(serviceId);
    return axiosClient.put<IBaseResponse>(url, body, {
      headers: { 'Content-Type': CONTENT_TYPE_FORM_DATA },
    });
  },

  deleteService: (serviceId: string) => {
    const url = urlApiService.deleteService(serviceId);
    return axiosClient.delete<IBaseResponse>(url);
  },
};

export default serviceApi;
